const companyRepo = (companyService) => {
  const createCompany = (input) => companyService.createCompany(input)

  const updateCompany = (input) => companyService.updateCompany(input)

  const listCompanys = (variables) => companyService.listCompanys(variables)

  const companyUsers = (id) => companyService.companyUsers(id)

  const syncListCompanys = (variables) => companyService.syncListCompanys(variables)

  const getCompany = (id) => companyService.getCompany(id)

  const getCompanyChanges = (id) => companyService.getCompanyChanges(id)

  const deleteCompany = (id) => companyService.deleteCompany(id)

  const removeUserFromCompany = (input) => companyService.removeUserFromCompany(input)

  const confirmCompanySync = (input) => companyService.confirmCompanySync(input)

  return {
    createCompany,
    confirmCompanySync,
    syncListCompanys,
    companyUsers,
    getCompanyChanges,
    updateCompany,
    listCompanys,
    getCompany,
    deleteCompany,
    removeUserFromCompany,
  }
}

export default companyRepo
